import App from './app/app';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppError from './components/app_error/app_error';
import { initFeedsWebViewApi } from './inter_op/feeds_web_view_api';
import { PreferredLanguageContextProvider } from './contexts/preferred_language/preferred_language_context_provider';
import { TokenContextProvider } from './contexts/token/token_context_provider';
import {
  captureException,
  initObservability,
  ObservabilityWrapper,
} from './utilities/observability';
import { AppStateContextProvider } from './contexts/app_state/app_state_context_provider';

initObservability();
initFeedsWebViewApi();

const rootElement = document.getElementById('root');

if (!rootElement) {
  const error = new Error('Root element with id "root" not found in the DOM');
  captureException(error);
  throw error;
}

createRoot(rootElement).render(
  <StrictMode>
    <ObservabilityWrapper fallback={<AppError />}>
      <TokenContextProvider>
        <PreferredLanguageContextProvider>
          <AppStateContextProvider>
            <App />
          </AppStateContextProvider>
        </PreferredLanguageContextProvider>
      </TokenContextProvider>
    </ObservabilityWrapper>
  </StrictMode>
);
